var FcCompaniesInputModule = /** @class */ (function () {
    function FcCompaniesInputModule() {
    }
    return FcCompaniesInputModule;
}());
export { FcCompaniesInputModule };
